<template>
    <div class="record-choose-list">
        <no-data
            v-if="noRecordData"
            v-bind:noteText="'记录空空如也~'">
        </no-data>
        <!-- 标题部分 -->
        <div v-if="recordList.length > 0" class="layout-rl-title dsp-flex">
            <div class="layout-rlt-letter">{{recordCurFirstL}}</div>
            <div class="layout-rlt-note">
                <div class="dsp-flex">
                    <span>年</span>
                    <span>月</span>
                    <span>日</span>
                    <span>时</span>
                </div>
            </div>
        </div>
        <!-- 列表部分 -->
        <div class="record-choose-main-list">
            <virtual-list id="RecordChooseList" ref="vsl" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="recordList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'com-record-item-w90'" />
        </div>
    </div>
</template>

<script>
import FamousChooseRecordItem from '../../components/famouspedia/FamousChooseRecordItem.vue'
import NoData from '../../components/common/NoData.vue'
export default {
    name: 'RecordChooseList',
    components: { NoData },
    computed: {
        noRecordData() {
            return this.$store.state.record.noRecordData;
        },
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        recordList() {
            return this.$store.state.record.recordListData;
        },
        scrollToIndex() {
            return this.$store.state.recordletter.scrollToIndex;
        },
        recordCurFirstL() {
            return this.$store.state.recordletter.recordCurFirstL;
        }
    },
    data() {
        return {
            itemComponent: FamousChooseRecordItem
        }
    },
    mounted() {
        this.$bus.on('updateScrollByLetter', this.clickLetterItem)
        this.$bus.on('updateScrollToTop', this.scrollToTop)
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initItemComponent();
        }, 20);
    },
    destroyed() {
        this.$bus.off('updateScrollByLetter', this.clickLetterItem)
        this.$bus.off('updateScrollToTop', this.scrollToTop)
    },
    methods: {
        initDom() {
            var barDom = document.getElementsByClassName('record-choose-bar')[0],
                titleDom = document.getElementsByClassName('layout-rl-title')[0],
                listDom = document.getElementById('RecordChooseList');
            if(listDom && barDom && titleDom) {
                listDom.style.height = (innerHeight - barDom.clientHeight - titleDom.clientHeight) + 'px';
            }
        },
        initItemComponent() {
            // 会根据条件来区分不同的元素
            this.itemComponent = FamousChooseRecordItem;
        },
        clickLetterItem(index) {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(index);
            }
        },
        scrollToTop() {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToIndex(0);
            }
        }

    }
}
</script>